<template>
  <main id="mainCtrl">
    <div style="margin-bottom: 10px;">
      <v-select v-model="selectedClinicId"
                class="large network-clinics-select"
                style="max-width: 750px;"
                placeholder="Выберите клинику"
                :options='clinics.map((clinic)=> {return {value: clinic.id, text: clinic.name, fullAddress: clinic.fullAddress} })'>
        <template v-slot="{ option }">
          <div class="textarea">
            <span>{{ option.text }}</span>
            <div style="height: 8px;"/>
            <small>{{ option.fullAddress }}</small>
          </div>
        </template>
      </v-select>
    </div>
    <div class="promo">
      <div class="promo__data">
        <div class="promo__title">Онлайн - запись на прием</div>

        <div class="promo__markers">
          <div class="promo__marker promo__marker_red">
            Интеграция с МедФлекс
          </div>
        </div>

        <div class="promo__text">
          <p>
            Включите интеграцию с сервисом МедФлекс, чтобы пациенты записывались на прием онлайн через наш сайт.
          </p>
          <ul>
            <li>Запись на прием круглосуточно</li>
            <li>Интеграция с вашей МИС/CRM</li>
            <li>Выгрузка расписаний врача</li>
            <li>Онлайн-запись пациентов</li>
            <li>Уведомления о новых записях</li>
          </ul>
        </div>
        <div class="promo__actions">
          <a href="https://medflex.ru/cabinet/integrations/" class="promo__btn medflexLink" target="_blank">
            Перейти в МедФлекс
          </a>
        </div>
      </div>
      <div class="promo__img">
        <img src="/img/online01.svg" alt=""/>
      </div>
    </div>
  </main>
</template>

<script>

export default {
  props: {
    clinics: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedClinicId: this.clinics[0].id,
    }
  },
  computed: {
    selectedClinic() {
      return this.clinics.find(item => item.id === this.selectedClinicId);
    }
  },
}
</script>

<style>
a.medflexLink:active, a.medflexLink:focus {
  color: #fff;
}
</style>
